import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  addEmployeeCertificate,
  deleteEmployeeCertificate,
  getEmployeeCertificate,
} from "../Service/profileService";
import moment from "moment";
import { TostMsg } from "../../../../App";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.memo(
  lazy(() => import("../../../../Shared/Sidebar/ComponentLoader"))
);
const Certificate = ({ employeeId, employee }) => {
  const [Isloading, setIsloading] = useState(false);
  const [certificateLst, setCertificateLst] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [file, setFile] = useState(null);
  const toster = useContext(TostMsg);
  const [certificateDeleteId, setCertificateDeleteId] = useState(null);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showContent, setSeleteContent] = useState([]);
  const [dateError, setDateError] = useState(false);
  let history = useHistory();
  const [imageUrls, setImageUrls] = useState([]);
  const mediaDefaultImage = "/images/no-data-found/feed_dummy.png";

  useEffect(() => {
    if (employeeId) {
      GetEmployeeCertificate();
    }
  }, [employeeId]);

  useEffect(() => {
    const loadImages = async () => {
      const promises = certificateLst.map((lst) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = lst?.CertificateImage || mediaDefaultImage;
          img.onload = () => resolve(img.src);
          img.onerror = () => resolve(mediaDefaultImage);
        });
      });

      const results = await Promise.all(promises);
      setImageUrls(results);
    };
    loadImages();
  }, [certificateLst, mediaDefaultImage]);

  async function GetEmployeeCertificate() {
    let body = {
      Id: 0,
      OrgId: userDetails.OrgId,
      EmpId: employeeId,
    };
    try {
      let response = await getEmployeeCertificate(body);
      setCertificateLst(response.Data);
    } catch (error) {
      setIsloading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const EditCertificate = async (lst) => {
    history.push(`/Certifecation/${lst?.id}`);
  };

  const handleCreatedlstDelete = (Id) => {
    setCertificateDeleteId(Id);
  };

  async function DeleteEmployeeCertificate() {
    setIsloading(true);
    if (certificateDeleteId) {
      let body = {
        Id: certificateDeleteId,
        // ModifiedBy: userDetails.EmpId,
      };
      try {
        await deleteEmployeeCertificate(body);
        setIsloading(false);
        GetEmployeeCertificate();
        GetMasterSystemAlertList("Certificate_Deleted", 0);
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsloading(false);
      }
    } else {
      toster.current.error("Try Again");
    }
  }

  const handleCloseModal = () => {
    history.push(`/AddCertification`);
  };

  return (
    <div className="pt-3 border-bottom-1 position-relation certificate-profilesection">
      <div className="mb-0">
        <h4 className="text-primary mb-3 sumh4 addprofile-action">
          Certificates & Recognitions
          {userDetails?.EmpId == employeeId && (
            <span>
              <a
                className="edit-btncss mb-2 love-icon"
                title="Add Certificate"
                onClick={() => {
                  handleCloseModal();
                  GetMasterSystemAlertList("Add_Certificates", 1);
                }}
              >
                <img src="/images/org-img/profile/add.png" className="w-100" />{" "}
              </a>
            </span>
          )}
        </h4>
        <div className="recommendations-wrapper">
          {certificateLst?.map((lst, index) => (
            <div
              key={index}
              className="recommendations-item"
              style={{ width: "calc(33% - 16px)" }}
            >
              <div
                className="media-feed-item has-background-image"
                style={{
                  backgroundImage: `url(${
                    imageUrls[index] || mediaDefaultImage
                  })`,
                }}
              >
                {userDetails?.EmpId == employeeId && (
                  <button
                    className="galleryeditbtn"
                    style={{ top: "3.2rem" }}
                    onClick={() => {
                      EditCertificate(lst);
                    }}
                    title="Edit"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-pencil"
                      viewBox="0 0 16 16"
                    >
                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                    </svg>
                  </button>
                )}
                {userDetails?.EmpId == employeeId && (
                  <button
                    onClick={() => {
                      handleCreatedlstDelete(lst?.id);
                      GetMasterSystemAlertList("Delete_Certificates", 1);
                    }}
                    className="gallerydeletebtn"
                    title="Delete"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-certificate"
                    style={{ top: "1rem" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-trash"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                      <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                  </button>
                )}
                <div className="item-overlay"></div>
                <a>
                  <div className="overlay-layer">
                    <div className="overlay-content">
                      <div
                        className="inner-content"
                        style={{ textAlign: "left" }}
                      >
                        <p className="media-title">{lst?.CertificateName}</p>
                        <p
                          className="align-items-center"
                          title={lst?.IssuingOrg}
                        >
                          By :- {lst?.IssuingOrg}
                        </p>
                        <div className="media-meta">
                          <span className="meta-item d-flex align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="11"
                              fill="currentColor"
                              className="bi bi-calendar me-1"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                            </svg>
                            From{" "}
                            {moment(lst?.ValidityStartDate).format(
                              "MMM DD YYYY"
                            )}
                            <span className="separator">|</span>
                            To &nbsp;
                            {(lst?.ValidityEndDate == "Perpetual Validity") ?<>{lst?.ValidityEndDate}</> : (<>{moment(lst?.ValidityEndDate).format("MMM DD YYYY")}</>)}
                            
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}

      <div className="modal fade" id="delete-certificate">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p> {showContent}</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="deletebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteEmployeeCertificate()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Certificate;
